import NewInput from './NewInput';
import RegularInput from './RegularInput';
import { getConfig } from 'config';

const component = getConfig().useNewInput ? NewInput : RegularInput;

export default component;
